//-------Configuring global constants here-------------
module.exports = global.config = {
    //--Application Name-------------
    title: "Fifopay",

};